import { CSSProperties } from 'react';
import { mediaQuery, minBreakpoints } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

import { nothsTheme } from 'src/styles/noths.theme';

export interface CSSVar extends CSSProperties {
  '--color'?: string;
}

const { color: nothsColor, font: nothsFont } = nothsTheme;

export const RichTextEditorStyle = css`
  max-width: 100%;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: var(--color, ${nothsColor.primary});

  h2 {
    font-family: ${nothsFont.family.secondary};
    font-size: ${nothsFont.size.M};
    line-height: '30px';
    font-weight: 600;
    margin: 0;
  }

  h3 {
    font-family: ${nothsFont.family.secondary};
    font-size: ${nothsFont.size.S};
    margin: 16px 0;
    font-weight: 400;
  }

  p,
  span,
  li,
  table {
    font-family: ${nothsFont.family.secondary};
    font-size: ${nothsFont.size.S};
    line-height: 24px;
    margin: 0 0 10px 0;
    font-weight: 400;
  }

  p:last-child {
    margin-bottom: 0;
  }

  a {
    color: #00a3eb;

    &:hover {
      color: ${nothsColor.primaryDarker};
    }
  }

  .tandc {
    font-size: 12px;
    line-height: 14px;
    margin-bottom: 5px;
  }

  ul,
  ol {
    padding-left: 20px;
  }

  table {
    box-sizing: border-box;
    border-collapse: collapse;
    border-spacing: 0;
  }

  thead td {
    padding: 10px 5px;
    background: ${nothsColor.primaryLighter};
    display: none;

    ${mediaQuery(
      { min: minBreakpoints.MEDIUM },
      css`
        display: table-cell;
      `,
    )};
  }

  tbody tr td:first-child {
    background: ${nothsColor.primaryLighter};

    ${mediaQuery(
      { min: minBreakpoints.MEDIUM },
      css`
        background: none;
      `,
    )};
  }

  tbody tr:last-child td:last-child {
    border-bottom-width: 1px;
  }

  td {
    padding: 5px;
    vertical-align: middle;
    display: block;
    border-style: solid;
    border-color: ${nothsColor.primaryLight};
    border-width: 1px 1px 0px 1px;

    ${mediaQuery(
      { min: minBreakpoints.MEDIUM },
      css`
        display: table-cell;
        border-width: 1px;
      `,
    )};
  }

  .button {
    font-family: ${nothsFont.family.primary};
    background-color: ${nothsColor.cerulean};
    color: ${nothsColor.white};
    text-transform: uppercase;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: auto;
    cursor: pointer;
    touch-action: manipulation;
    white-space: nowrap;
    text-decoration: none;
    letter-spacing: 0.8px;
    background-repeat: no-repeat;
    border-radius: 3px;
    box-sizing: border-box;
    padding: 0 18px;
    font-size: ${nothsFont.size.S};
    line-height: ${nothsFont.size.L};
    height: 47px;

    &:hover,
    &:focus,
    &:active {
      backface-visibility: hidden;
    }
    &:disabled {
      cursor: not-allowed;
      background: ${nothsColor.silver};
      color: ${nothsColor.silverChalice};
    }
    &::-moz-focus-inner {
      border: 0;
      padding: 0;
    }
  }

  &[data-small-text='true'] {
    h2 {
      line-height: normal;
    }
    p,
    span,
    li,
    table {
      font-family: ${nothsFont.family.primary};
      font-size: ${nothsFont.size.XS};
      line-height: normal;
      margin: 0px 0px 18px;
    }
  }
`;
